/* eslint-disable lingui/no-unlocalized-strings -- U02: legacy wire values and synthetic backend data; UI uses Lingui. */
import { z } from 'zod';

import { defineDataSource } from '@/shared/page';

import { getBankSlip } from './bank-slip.api';
import { bankSlipKeys } from './bank-slip.queries';
import { bankSlipResponseSchema } from './bank-slip.wire';

export const bankSlipParams = z.object({
  id: z.string().min(1),
  isRoot: z.boolean().default(false),
});
export const bankSlipDetailSource = defineDataSource({
  id: 'bankSlip.detail',
  description:
    'Bank slip details, payment identifiers and instruction history for an authorized billing host.',
  shape: 'record',
  params: z.object({ id: z.string().min(1) }),
  response: bankSlipResponseSchema,
  permission: 'none',
  reason:
    'The billing host enforces access; the legacy bank slip panel has no separate permission gate.',
  sensitivity: 'restricted',
  limits: { staleTimeMs: 30_000 },
  key: ({ id }) => bankSlipKeys.detail(id),
  fetch: ({ id }, { signal }) => getBankSlip(id, signal),
});
